/**
 * Given a string, this will strip out all non-number characters and convert
 * the value to a number.
 */
export function convertNumericStringToNumber(value) {
    var number = Number(value.replace(/[^\d.-]/g, ''));
    return Number.isNaN(number) ? 0 : number;
}
//# sourceMappingURL=convert-numeric-string-to-number.js.map